<template>
  <div>
    <Panel :data="fee"/>
    <hr>

    <h3>Histórico de Multas</h3>
    <FeeHistories v-if="fee && fee.id" :fee="fee"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Panel from '../Panel.vue'
import FeeHistories from './FeeHistories'

import { mapMutations } from 'vuex'

export default {
  components: { Panel, FeeHistories },
  computed: {
    fee() {
      return this.getModel
    },
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: ({model}) => this.setNameBreadcrumb(model.id)
    })
  },
  data: () => ({
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Fee',
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: { required: false }
  }
}

</script>

<style scoped>

</style>